// Auto-flips when First Round starts (March 19, 2026 noon EST)
export const TOURNAMENT_NOT_STARTED = Date.now() < new Date('2026-03-19T12:00:00-05:00').getTime();
export const TOURNAMENT_STARTED = !TOURNAMENT_NOT_STARTED;
export const BRACKET_IMG_PATH = '/bracket2026.png';

export function getRoundName(roundNum) {
    switch (roundNum) {
        case 64:
            return 'Lose in First Round';
        case 32:
            return 'Lose in Second Round';
        case 16:
            return 'Lose in Sweet 16';
        case 8:
            return 'Lose in Elite 8';
        case 4:
            return 'Lose in Final Four';
        case 2:
            return 'Lose in Championship';
        case 1:
            return 'Win Championship';
        default:
            return 'Error';
    }
}
